import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import ProductsSection from './components/ProductsSection';
import Benefits from './components/Benefits';
import HowItWorks from './components/HowItWorks';
import AboutAshish from './components/AboutAshish';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

const Landing = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <ProductsSection />
        <Benefits />
        <HowItWorks />
        <AboutAshish />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
